import React from "react";

const Jira = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <path
            d="M33.629 17.105 19.837 3.335 18.5 2 8.118 12.365l-4.747 4.74a1.266 1.266 0 0 0 0 1.79l9.485 9.47L18.5 34l10.382-10.365.16-.16 4.587-4.58a1.266 1.266 0 0 0 0-1.79ZM18.5 22.73 13.762 18l4.738-4.73L23.238 18 18.5 22.73Z"
            fill="#2684FF"
        />
        <path
            d="M18.5 13.5c-1.433-1.49-2.74-3.765-2.746-5.871-.006-2.107.822-3.63 2.246-5.129l-10 10 5.425 5.5 5.075-4.5Z"
            fill="url(#jiraa)"
        />
        <path
            d="M23.028 18 18 22.74a7.947 7.947 0 0 1 1.832 2.583c.424.966.643 2.001.643 3.047a7.565 7.565 0 0 1-.643 3.047A7.945 7.945 0 0 1 18 34l11-10.37L23.028 18Z"
            fill="url(#jirab)"
        />
        <defs>
            <linearGradient
                id="jiraa"
                x1={17.187}
                y1={8.452}
                x2={10.579}
                y2={14.808}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.18} stopColor="#0052CC" />
                <stop offset={1} stopColor="#2684FF" />
            </linearGradient>
            <linearGradient
                id="jirab"
                x1={18.958}
                y1={27.467}
                x2={25.535}
                y2={20.49}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.18} stopColor="#0052CC" />
                <stop offset={1} stopColor="#2684FF" />
            </linearGradient>
        </defs>
    </svg>
);

export default Jira;
